import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ExamAiInsightsChatLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'ExamAiInsightsChat' */ './ExamAiInsightsChat')
);

export default () => {
	return {
		path: ':chatId',
		element: <AsyncLoading component={<ExamAiInsightsChatLazy />} />,
	};
};
